import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseDropdownComponent } from '../../baseclasses/BaseDropdown.component';

@Component({
    selector: 'my-tradename-dropdown',
    templateUrl: './TradeNameDropdown.component.html',
    providers: [{ provide: BaseDropdownComponent, useExisting: forwardRef(() => TradeNameDropdownComponent) }]
})
export class TradeNameDropdownComponent extends BaseDropdownComponent {


    tradeNames: ent.TradeName[] = [];
    constructor(private domainDataService: serv.DomainDataService) {
        super();
    }


    ngOnInit(): void {
    }

    public load() {

        var filter: filters.TradeNameFilter = {};
        this.domainDataService.getTradeNames(filter).subscribe(x => this.onGetTradeNamesDone(x));
    }

    onGetTradeNamesDone(items: ent.TradeName[]) {
        this.tradeNames = items;
        this.selectItems.push({ label: "", value: Constants._NONE });
        items.forEach(y => this.selectItems.push({ label: y.FullName, value: y.ID }));
        if (this.selectedID) {
            this.value = this.selectedID;
        }
        else {
            if (this.selectDefault) {
                var defaultItems = items.filter(x => x.Code == Constants._DEFAULT_TRADE_NAME_CODE);
                if (defaultItems.length > 0) {
                    this.value = defaultItems[0].ID;
                }
            }
        }
    }

}